/**
 * Data-List Component
 */

import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Property Card Vue Component');
    app.vueApp.component(
        'property-card',
        defineAsyncComponent(async () => import('./PropertyCard.vue'))
    );
    app.vueApp.component(
        'property-card-mobile',
        defineAsyncComponent(async () => import('./PropertyCardMobile.vue'))
    );
};
